<!--
 * @Description: 消防场所统计
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-22 09:17:45
 * @LastEditTime: 2024-07-26 17:21:18
-->
<template>
<div class="fireFacChartsContainer">
  <div class="chartItem">
    <div class="select-box">
      <el-select v-model="type" @change="handleChange">
        <el-option
          v-for="item in optionData"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="itemBox">
      <div class="chartBox">
        <echarts chart-id="fireFacChart" :chart-option="options" v-if="isShow"></echarts>
        <img src="../../assets/img/bigScreen/noData.png" alt="" v-else>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
var dayjs = require('dayjs')
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      type: '',
      optionData: [],
      isShow: true,
      imgSrc: require('../../assets/img/bigScreen/no-data.png'),
      options: {
        tooltip: {
          trigger: 'axis',
        },
        // legend: {
        //   data: [
        //     { name: '在线', itemStyle: { color: '#2CFEF1' } },
        //     { name: '离线', itemStyle: { color: '#2AA8FC' } },
        //   ],
        //   itemWidth: 15,
        //   itemHeight: 10,
        //   textStyle: { color: '#fff', fontSize: 13 },
        //   right: 20,
        // },
        grid: {
          top: '8%',
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: { show: false },
            axisLine: {
              lineStyle: { color: '#131E3B' },
            },
            axisLabel: {
              // interval: 0,
              color: '#fff',
              fontSize: 13,
              // rotate: 30,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#fff', fontSize: 13 },
            // axisLabel: {
            //   formatter: '{value} 个',
            // },
            axisTick: { show: true },
            axisLine: {
              show: true,
              lineStyle: { color: '#131E3B' },
            },
            axisLabel: { color: '#fff', fontSize: 13 },
            splitLine: { show: false },
          },
        ],
        series: [
          {
            name: '',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 台'
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2CFEF1' },
                { offset: 1, color: '#000B28' },
              ]),
              borderRadius: 1,
            },
            barMaxWidth: 10,
            data: [],
          }
        ],
      },
    }
  },
  created() {
    this.getType()
    this.getEchartsPolice()
  },
  mounted() {},
  methods: {
    handleChange (e) {
      this.getEchartsPolice(e)
    },
    async getType() {
      let { code, msg, data } = await this.request.get(`/front/device/class/all`)
      if (code != 200) return

      let all = { id: '', name: '全部设备' }

      this.optionData = [all, ...data]
    },
    async getEchartsPolice(e) {
      let classId = e || this.type
      let { code, msg, data } = await this.request.post(`/front/device/placeTypeDeviceStatistics`, { classId })
      let options = JSON.parse(JSON.stringify(this.options))
      
      console.log(data)
      if (code != 200)  {
        this.isShow = false
        return
      }
      if(data.length < 1){
        this.isShow = false
        return
      }
      this.isShow = true

      let xAxisData = []
      let seriesData = []
      xAxisData = data.map(({ deviceCount, placeName }) => {
        seriesData.push(deviceCount || 0)
        return placeName || ''
      })
      console.log(2222, options)
      options.xAxis[0].data = xAxisData
      options.series[0].data = seriesData

      this.options = options
    },
  }
}
</script>

<style lang="scss" scoped>
.fireFacChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;

  .chartItem {
    width: 100%;
    height: 100%;
    .select-box {
      height: 40px;
      text-align: right;
      margin-right: 20px;
    }

    .itemBox {
      width: 100%;
      height: calc(100% - 42px);

      .chartBox {
        width: 100%;
        height: 100%;
        >img {
          width: 90%;
          height: 90%;
          margin-top: 5%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.fireFacChartsContainer {
  // ======== 下拉选项 =========
  .el-select {
    .el-input {
      width: 150px;
      &.is-active .el-input__inner, .el-input__inner:focus {
        border-color: rgba(47,134,226,.9) !important;
      }
      .el-input__inner {
        background-color: transparent;
        border: 1px solid #203156;
        color: #fff;
        height: 38px;
        line-height: 38px;
        &::-webkit-input-placeholder {
          /* WebKit browsers，webkit内核浏览器 */
          color: #999;
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999;
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #999;
        }
        &:hover {
          border-color: rgba(255,255,255,.3);
        }
      }
      &.is-disabled .el-input__inner {
        background-color: rgba(71, 84, 113, .4);
        border-color: #203156;
        color: #617792;
      }
    }
  }
}
</style>
